<template>
  <div class="course_item" @click="handleCoursePath(course)">
    <el-image class="img" :src="course.cover" fit="cover"></el-image>
    <div class="course_content">
      <div class="course_title ellipsis" :title="course.title">{{ course.title }}</div>
      <div class="course_item_sub_title">
        <p class="top">
          <span class="time">{{ course.updateTime }}</span>
          <span class="progress"> 已学{{ course.studyProgress }}% </span>
        </p>
        <p>发布人：{{ course.updateName }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    course: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    handleCoursePath(course) {
      this.$emit("setCoursePath", course);
    },
  },
};
</script>
<style lang="scss" scoped>
.course_item {
  border: 1px solid #eeeeee;
  cursor: pointer;
  transition: all 0.3s;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0px 0px 16px 0px rgba(247, 137, 25, 0.21);
  }
  .img {
    width: 100%;
    height: 160px;
    display: block;
  }
  .course_content {
    padding: 18px 15px;
    .course_title {
      font-size: 18px;
      margin-bottom: 10px;
    }
    .course_item_sub_title {
      font-size: 12px;
      color: #999999;
      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 3px;
        line-height: 1;

        .progress {
          color: #333;
          padding: 3px 7px;
          background: #fec650;
          border-radius: 10px;
        }
      }
    }
  }
}
</style>
